export interface VerbalPaneOptions {
  text: string;
}

export interface VerbalPaneHandle {
  root: HTMLElement;
  update(opts: VerbalPaneOptions): void;
  destroy(): void;
}

export function createVerbalPane(root: HTMLElement, opts: VerbalPaneOptions): VerbalPaneHandle {
  function render(state: VerbalPaneOptions): void {
    root.replaceChildren();
    const p = document.createElement('p');
    p.className = 'fn-verbal-pane';
    p.textContent = state.text;
    root.appendChild(p);
  }
  let current = opts;
  render(current);
  return {
    root,
    update(next) {
      current = next;
      render(current);
    },
    destroy() {
      root.replaceChildren();
    },
  };
}
